import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IndexTable from "components/UI/DataTable/IndexTable";
import IndexLayout from "layouts/IndexLayout";

const moduleName = "notifications";

const styles = () => ({
  root: {
    flexGrow: 1,
  },
});

class NotificationsIndex extends React.Component {
  render() {
    const { classes, notifications, isLoading } = this.props;

    return (
      <div className={classes.root}>
        <IndexLayout moduleName={moduleName}>
          <IndexTable
            headers={headers}
            rows={notifications}
            moduleName={moduleName}
            isLoading={isLoading}
            actions={{
              edit: false,
              view: true
            }}
          />
        </IndexLayout>
      </div>
    );
  }
}

const headers = [
  { alias: "Customer", key: "customerName" },
  { alias: "Region", key: "regionName" },
  { alias: "Equipment", key: "equipmentName" },
  { alias: "Agreement", key: "agreementType" },
  { alias: "Status", key: "status", format: 'status' },
];

export default withStyles(styles)(NotificationsIndex);
